<script lang="ts">
    import { getKirbyPage } from "../../api/kirby/api"
    import { spaLink } from "../../functionTools/routing"
    import { lang, location } from "../../store"

    let {
        text,
        page_ref,
        isButton,
        setModal,
        type,
    }: {
        text: string
        page_ref?: string
        type: "white" | "transparent"
        isButton?: boolean
        setModal?: () => void
    } = $props()
    let path = $state("")

    function loadPath(currentLang: string) {
        if (!page_ref) return
        getKirbyPage(page_ref, {
            url: true,
        }).then((page) => {
            if (!page) return
            path = `/${currentLang}/` + page.url.split(`/${currentLang}/`).pop()
        })
    }

    // Top-Level: nur SSR (goja löst Promises synchron)
    if (typeof window === "undefined") loadPath(String($lang || ""))

    // $effect: Client + SPA-Sprachwechsel
    $effect(() => {
        loadPath(String($lang || ""))
    })

    let active = $state(false)
</script>

{#snippet icon()}
    {@const isActive = $location.path.includes(path)}
    <div class:isActiveDot={isActive} style={isActive ? "" : "display: none;"}>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <rect x="9" y="9" width="6" height="6" rx="3" fill={type == "white" ? "var(--dark-100)" : "white"}></rect>
        </svg>
    </div>
{/snippet}
{#if isButton}
    <button class="nav-titles" onclick={setModal}>
        {text}
        {@render icon()}
    </button>
{:else}
    <a
        href={path}
        use:spaLink
        target="_self"
        class="nav-titles"
        onmouseenter={() => (active = true)}
        onmouseleave={() => (active = false)}
    >
        {text}
        {@render icon()}
    </a>
{/if}
